import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_brand_values_local: FaireCategoryEntity = {
  token: "cat_brand-values-local",
  type: "category",
  name: "Made locally",
  level: 2,
  parentToken: "cat_brand-values",
  href: "/category/made-locally",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
